module.exports = __webpack_public_path__ + "static/80-8bfd7e34476f3f89ac2572f463f17975.jpeg";